// App.tsx
import React, { Suspense, lazy, useEffect, useState } from "react";
import { Routes, Route } from "react-router-dom";
import "./App.css";

import Loader from "./components/loader/Loader";
import CustomerFeedBack from "./components/customer-feedback/CustomerFeedBack";
import { Toaster } from "react-hot-toast";
import { MainRoutes } from "./routes/pages";
import Home from "./pages/Home/Home";
import './styles/variables.scss';
import ScrollToTop from "./components/scroll-to-top/ScrollToTop";
const Header = lazy(() => import("./components/header/Header"));
const Sidebar = lazy(() => import("./components/sidebar/Sidebar"));
const ChatBox = lazy(() => import("./components/chatbot/ChatBot"));
const Footer = lazy(() => import("./components/footer/Footer"));

function App() {
  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsSticky(window.scrollY > 100);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className={`App ${isSticky ? "sticky-active" : ""}`}>
      <Toaster position="top-right" />
      <Suspense fallback={<Loader />}>
      <ScrollToTop />
        <Header />
        {/* <Sidebar /> */}
        <CustomerFeedBack />
        <ChatBox />
        <Routes>
          <Route path="/" element={<Home />} />
          {MainRoutes.map((route, idx) => (
            <Route key={idx} path={route.path} element={<>{route.element}</>} />
          ))}
        </Routes>
        
        <Footer />
      </Suspense>
    </div>
  );
}

export default App;
